import { render, staticRenderFns } from "./pr-number.vue?vue&type=template&id=2b2e6a29&"
import script from "./pr-number.vue?vue&type=script&lang=js&"
export * from "./pr-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports